import find from 'lodash/find';
import concat from 'lodash/concat';
import orderBy from 'lodash/orderBy';
import ReactDOM from 'react-dom';
import React from 'react';
import findIndex from 'lodash/findIndex';
import GeoJSON from 'ol/format/GeoJSON';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import Circle from 'ol/style/Circle';
import Cluster from 'ol/source/Cluster';
import Overlay from 'ol/Overlay';
import { getLayer } from '../../openlayers-utils/layer-utilities';
import Select from 'ol/interaction/Select.js';
import { pointerMove } from 'ol/events/condition.js';
import VectorLayer from 'ol/layer/Vector';
import async from 'async';
import ProjectPopup from './project-popup/project-popup';
import LayerSubpanel from './layer-subpanel/layer-subpanel';
import ProjectPanel from './project-panel';
import { createSelector } from 'redux-bundler';
import Disclaimer from './disclaimer';
import staticEapStructures from './staticEAPStructures.json';


///testing
import VectorTileSource from 'ol/source/VectorTile';
import {VectorTile as VectorTileLayer} from 'ol/layer';
import Projection from 'ol/proj/Projection';
import geojsonvt from 'geojson-vt';

// Converts geojson-vt data to GeoJSON
const replacer = function(key, value) {
  if (value.geometry) {
    var type;
    var rawType = value.type;
    var geometry = value.geometry;

    if (rawType === 1) {
      type = 'MultiPoint';
      if (geometry.length == 1) {
        type = 'Point';
        geometry = geometry[0];
      }
    } else if (rawType === 2) {
      type = 'MultiLineString';
      if (geometry.length == 1) {
        type = 'LineString';
        geometry = geometry[0];
      }
    } else if (rawType === 3) {
      type = 'Polygon';
      if (geometry.length > 1) {
        type = 'MultiPolygon';
        geometry = [geometry];
      }
    }

    return {
      'type': 'Feature',
      'geometry': {
        'type': type,
        'coordinates': geometry
      },
      'properties': value.tags
    };
  } else {
    return value;
  }
};
const mmcHost = process.env.REACT_APP_MMC_ENV;
const cwbiHost = process.env.REACT_APP_CI;
const PUBLIC_URL = process.env.PUBLIC_URL;

const symbolMap = {
  "dam_study": 'c',
  "levee_study":'g',
  "cwms": 'b',
  "silver_jackets":'j',
  "fema":'d',
  "flood_fight":'f',
  "simdams":'z'
}

const colorMap = {
  "dam_study": '#3B678C',
  "levee_study":'#8A8278',
  "cwms": '#58B185',
  "silver_jackets":'#9E3E32',
  "fema": '#CD4E48',
  "flood_fight":'#E4AD2E'
}

// List of hosts which require a local store of fim viewer data (to avoid CORS errors)
const localhosts = ['localhost', 'damsdev.net'];

const nidFeatures = [
  {
    label: 'Centerlines',
    key: 'dam_centerlines'
  },
  {
    label: 'Outlets',
    key: 'dam_outlets'
  },
  {
    label: 'Cross Sections',
    key: 'dam_cross_section_lines'
  },
  {
    label: 'Leveed Areas',
    key: 'dams_leveed_areas'
  },
  {
    label: 'Spillways',
    key: 'dam_spillways'
  },
  {
    label: 'Station Points',
    key: 'dam_station_points'
  },
];

const overlayDiv = document.createElement('div');
overlayDiv.setAttribute('id', 'popup');
overlayDiv.style.transform = 'translate(0, -12px)';
document.getElementById('root').appendChild(overlayDiv);
var popup = new Overlay({
  element: document.getElementById('popup'),
  positioning: 'bottom-center'
});

const libraryPoints = getLayer({
  serviceType: 'LocalVector',
  visible: true,
  geometryType: 'Point'
})

const clusterSource = new Cluster({
  distance: 40,
  source: libraryPoints.getSource()
});

const clusters = new VectorLayer({
  source: clusterSource,
  renderMode: 'image',
  style: function(feature, res) {
    const children = feature.get('features');
    if(!children) return null;
    const f = children[0];
    const type = f.get('LIBRARY_TYPE');
    let txt = symbolMap[type] || 'h';
    let font = 'normal 14px ds-icons';
    if(type==='simdams') {
      font='normal 14px fv-icons'
    }
    let color = colorMap[type];
    if(children.length > 1){
      txt = children.length.toString();
      font = 'bold 10px sans-serif';
      color = '#4881B2'
    }
    return new Style({
      image: new Circle({
        radius: 12,
        stroke: new Stroke({
          color: '#fff',
          width: 1
        }),
        fill: new Fill({
          color: color
        })
      }),
      text: new Text({
        text: txt,
        font: font,
        fill: new Fill({
          color: '#fff'
        })
      })
    });
  }
});

var selectPointerMove = new Select({
  condition: pointerMove,
  multi: false,
  layers:[clusters],
  style: (feature, r) => {
    const children = feature.get('features');
    if(!children) return null;
    const f = children[0];
    const type = f.get('LIBRARY_TYPE');
    let txt = symbolMap[type] || 'h';
    let font = 'normal 11px ds-icons';
    if(type==='simdams') {
      font='normal 11px fv-icons'
    }
    let color = colorMap[type];
    if(children.length > 1){
      txt = children.length.toString();
      font = 'bold 10px sans-serif';
      color = '#4881B2'
    }
    return new Style({
      image: new Circle({
        radius: 14,
        stroke: new Stroke({
          color: '#fff',
          width: 2
        }),
        fill: new Fill({
          color: color
        })
      }),
      text: new Text({
        text: txt,
        font: font,
        fill: new Fill({
          color: '#fff'
        })
      })
    });
  }
});

const mapExtentStyle = (feature) => {
  return new Style({
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.1)'
    }),
    stroke: new Stroke({
      color: 'rgba(255, 0, 0, 0.5)',
      width: 2
    }),
    text: new Text({
      textAlign: 'center',
      textBaseline: 'middle',
      font: 'bold 12px Verdana',
      text: feature.get('PAGE_NUMBER'),
      fill: new Fill({ color: 'black' }),
      stroke: new Stroke({ color: 'white', width: 0.5 })
    })
  });
}

function parseData(raw){
  const featureCollection = {
    type: 'FeatureCollection',
    features: []
  }
  featureCollection.features = raw.map((lib) => {
    return { 
      type: 'Feature',
      geometry: {
        type: "Point",
        coordinates: [lib.LON, lib.LAT]
      },
      properties: Object.assign({}, lib)
    }
  });
  return featureCollection;
}


function traverse(o, cb) {
  if(o.root===false) {
    traverse(o.parent, cb)
  }else{
    cb(o.parent.id)
  }      
}
function getRoot(item, cb) {
  const cb2 = function(result) {
    cb(result)
  }
  traverse(item, cb2);
}

export default {
  name: 'ds',

  getReducer(){
    const initialState = {
      clusterLayer:null,
      threeDLayer: null,
      shouldLoadDatsets: false,
      shouldLoadProjectId: null,
      shouldLoadProjectType: null,
      shouldLoadLibraries: true,
      shouldRenderConfig: false,
      shouldRenderMSExplorer: false,
      shouldRenderMapsOnDemand: false,
      shouldAddSelect: true,
      shouldParseUrl: false,
      shouldRegister: false,
      shouldLoadHSIP: true,
      ignoreSelect: false,
      visibleProject: null,
      configRoot: null,
      libraries:[],
      loadingLibrary:[],
      openFolders:[],
      statusChange: false,
      subPanelType: null,
      checkingExtent: false,
      shouldRenderRasterReclass: false,
      openProjects: {SIMDAMS:{}, NID:{}}
    }

    return (state = initialState, { type, payload }) => {

      switch(type){
        case 'DS_OPENED_PROJECT':
        case 'DS_CLOSED_PROJECT':
        case 'DS_PROJECT_FOLDER_CHANGE':
        case 'DS_PROJECT_DATA_LOADING':
        case 'DS_PROJECT_DATA_LOADED':
        case 'DS_ROOT_CREATED':
        case 'DS_CONFIG_PICKED':
        case 'DS_CONFIG_DISPLAYED':
        case 'DS_LIBRARIES_LOADING':
        case 'DS_LIBRARIES_ERROR':
        case 'DS_LIBRARIES_SUCCESS':
        case 'DS_PARSE_URL':
        case 'DS_LAYER_TREE_LOADED':
        case 'DS_ADDED_SELECT':
        case 'DS_HSIP_LOADING':
        case 'DS_MOUSOVER':
        case 'DS_MOUSEOUT':
        case 'DS_MSEXPLORER_PICKED':
        case 'DS_MSEXPLORER_DISPLAYED':
        case 'DS_RASTER_RECLASS_PICKED':
        case 'DS_RASTER_RECLASS_DISPLAYED':
        case 'DS_MAPS_ON_DEMAND_PICKED':
        case 'DS_MAPS_ON_DEMAND_DISPLAYED':
        case 'DS_IDENT_REGISTERED':
        case 'DS_ACCEPT_DISCLAIMER':
          return Object.assign({}, state, payload);
        case 'UI_OPENED_PRIMARY_PANEL':
          return Object.assign({}, state, {});
        default:
          return state;
      }

    }
  },
  // doDsShowDisclaimer: ()=> ({dispatch, apiGet, store}) => {
  //   dispatch({type:'LAYERS_LOADING_START', payload: { isLoading: true, isLoadingText: 'Waiting For User to Accept Disclaimer' }});  
  // },
  doDsAcceptDisclaimer: ()=> ({dispatch, apiGet, store}) => {
    dispatch({type: 'DS_ACCEPT_DISCLAIMER', payload: { shouldLoadLibraries: true, shouldLoadHSIP: true }});
    // store.doLogin();
    store.doCloseModalWindow();   
  },
  
  doDsLoadHSIPLayers: ()=> ({dispatch, apiGet, store}) => {
    dispatch({type: 'DS_HSIP_LOADING', payload: { shouldLoadHSIP: false }});
    const parentUid = store.selectTreeViewRootId();
    let basemapUrl = localhosts.includes(window.location.hostname)? `./assets/BasemapLayers.json` : `${cwbiHost}/default/getBasemapLayers`;
    apiGet(basemapUrl, (err, response, body) => {
      if(err || response.statusCode !== 200) {        
        dispatch({ type: 'DS_PROJECT_DATA_LOAD_ERROR', payload: { err: err, notification: {
          level: 'error',
          title: 'Failed To Retrive National Layers',
          message: JSON.stringify(err)
        }}})
      }else{
        const data = JSON.parse(body);
        const sortedLayers = orderBy(data, ['parentId','id', 'displayName'], ['asc', 'desc', 'desc']);
        sortedLayers.forEach((lyr) => {
          if(!lyr.parentUid){
            lyr.parentUid = parentUid;
          }          
          if(!lyr.hasOwnProperty('visible')) lyr.visible = false;
          if(lyr.type !=='Folder' && lyr.root !== true  && lyr.type.indexOf('Arc') === -1) {
            lyr.info = {
              // url:`${cwbiHost}/public/getInfo?type=public&layer=${lyr.layerList[0]}`
            }
          }
          store.doAddLayer(lyr);      
        });
        for (let feature of nidFeatures) {
          store.doAddLayer({
            id: 0,
            displayName: feature.label,
            dsName: "NID",
            info: {},
            geometryType: "SERVICE",
            layerList: [feature.key],
            legendURL: `./assets/legend/${feature.key}.png`,
            opacity: 0.6,
            parentId: 5,
            parentUid: "101d1cad-fc70-4e95-848e-67842497c5b3",
            serviceType: "WMS",
            serviceURL: "https://nld2dev.net/mapcache/private",
            type: "WMS",
            uid: `101d1cad-fc70-4e95-848e-67842497c5b3-${feature.key}`,
            url: "https://nld2dev.net/mapcache/private",
            visible: false
          });
        }
      }
    });
  },

  doDsDeleteFromLoadingLibrary: (library) => ({dispatch, store}) => {
    const loadingLibrary = store.selectDsLoadingLibrary();
    const idx = findIndex(loadingLibrary, {library:library});
    if(idx !== -1) {
      loadingLibrary.splice(idx, 1);
    }
  },
  doDsDeleteFromOpenFolders: (library) => ({dispatch, store}) => {
    const openFolders = Object.assign({}, store.selectDsOpenFolders());
    const idx = findIndex(openFolders, {library:library});
    if(idx !== -1) {
      openFolders.splice(idx, 1);
    }
  },
  
  doOpenLinkedProject:(projectId, libraryType) => ({dispatch, store}) => {
    const idMap = store.selectIdMap();
    const openProjects = Object.assign({}, store.selectOpenProjects());
    let projectType = 'NID';
    
    if(libraryType==='simdams') {
      projectType = 'SIMDAMS'
    }
     const availableLibs = store.selectDsLibraries();
     const project = find(availableLibs, {LIBRARY_ID:projectId, LIBRARY_TYPE:libraryType}) || {};
    store.doSetView({
      center: [project.LON, project.LAT],
      zoom: 11
    });
    const library = openProjects[projectType][project.LIBRARY_ID];
    if(library) {
      store.doOpenPrimaryPanel({
        openedBy: 'ds-tree',
        options: {library: library, datasets: null},
        children:[ ProjectPanel ]
      })
    }else{
      openProjects[projectType][project.LIBRARY_ID] = project;
      dispatch({type: 'DS_OPENED_PROJECT', payload: { openProjects: openProjects, shouldLoadDatsets: true, shouldLoadProjectId: project.id, shouldLoadProjectType: project.LIBRARY_TYPE }});
    }
    
  },

  doOpenProject: (project) => ({dispatch, store}) => {
    const idMap = store.selectIdMap();
    const openProjects = Object.assign({}, store.selectOpenProjects());
    let projectType = 'NID';
    
    if(project.LIBRARY_TYPE==='simdams') {
      projectType = 'SIMDAMS'
    }
    if(!project.datasets) project.datasets = [];
    // const c3d = window.Cesium.Cartesian3.fromDegrees(project.LON, project.LAT, 43040.245494263276);
    store.doSetView({
      center: [project.LON, project.LAT],
      // position:c3d,
      zoom: 11
    });
    const library = openProjects[projectType][project.id];
    if(library) {
      store.doOpenPrimaryPanel({
        openedBy: 'ds-tree',
        options: {library: library, datasets: null},
        children:[ ProjectPanel ]
      })
    }else{
      openProjects[projectType][project.id] = project;
      dispatch({type: 'DS_OPENED_PROJECT', payload: { openProjects: openProjects, shouldLoadDatsets: true, shouldLoadProjectId: project.id, shouldLoadProjectType: project.LIBRARY_TYPE }});
    }
    
  },
  doRetrieveExtent: (lyr) => ({dispatch, store}) => {
  },

  doCloseProject: (project) => ({dispatch, store}) => {
    const idMap = store.selectIdMap();
    const openProjects = Object.assign({}, store.selectOpenProjects());
    let projectType = 'NID';
    if(project.LIBRARY_TYPE==='simdams') {
      projectType = 'SIMDAMS'
    }
    const rootId = idMap[`root-${projectType}-${project.id}`]
    store.doTreeRemove(rootId);
    delete openProjects[projectType][project.id];
    store.doClosePrimaryPanel();
    store.doDsDeleteFromLoadingLibrary(`${projectType}-${project.id}`)
    store.doDsDeleteFromOpenFolders(`${projectType}-${project.id}`)
    dispatch({type: 'DS_CLOSED_PROJECT', payload: { openProjects: openProjects }});
  },

  doLoadLibraries: () => ({dispatch, store, apiGet}) => {
    dispatch({type:'DS_LIBRARIES_LOADING', payload: { shouldLoadLibraries: false }});
    dispatch({type:'LAYERS_LOADING_START', payload: { isLoading: true, isLoadingText: 'Loading Dam and Levee Safety Projects' }});
    const map = store.selectMap();
    async.parallel([
      function(callback){
        apiGet(`${cwbiHost}/fim/getAllEAPStructure`, (err, response, body) => {
          if(err || response.statusCode !== 200){
            if (localhosts.includes(window.location.hostname)) {
              return callback(null, staticEapStructures.map((lib) => {
                return Object.assign(lib, {
                  id:lib.ID,
                  info:{
                    url:`${cwbiHost}/usace/getInfo?type=library&libraryType=${lib.LIBRARY_TYPE}&library=IWRSS-${lib.id}&mmc=[]`
                  }
                })
              }))
            } else {
              callback({err:err,response:response});
            }
          }else{
            try{
              const data = JSON.parse(body);
              return callback(null, data.map((lib) => {
                return Object.assign(lib, {
                  id:lib.ID,
                  info:{
                    url:`${cwbiHost}/usace/getInfo?type=library&libraryType=${lib.LIBRARY_TYPE}&library=IWRSS-${lib.id}&mmc=[]`
                  }
                })
                  
              }))
            }catch(err){
              callback({err:err,response:response});
            }
          }
        })
      },
      
    ],
      (err, results) => {
        if(err) {
          dispatch({ type: 'DS_LIBRARIES_ERROR', payload: { err: err, notification: {
            level: 'error',
            title: 'Failed To Retrive FIM Libraries',
            message: JSON.stringify(err)
          }}})
          dispatch({type:'LAYERS_LOADING_STOP', payload: { isLoading: false, isLoadingText: '' }});
        }else{
          if(!results[0]) results[0] = [];
          if(!results[1]) results[1] = [];
          const data = [...results[0], ...results[1]];
          const points = parseData(data);
          const features = (new GeoJSON()).readFeatures(points, {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
          libraryPoints.getSource().addFeatures(features);
          //map.addLayer(clusters); 
          const obj={};          
          obj.layerList=['library']
          obj.dsName='NID';
          obj.info = {
            parentTableId:0
          }
          obj.displayName='NID Structures'
          obj.parentUid = store.selectTreeViewRootId();
          obj.serviceType ='LocalVector';
          obj.type= 'LocalVector';
          obj.visible= true;
          obj.geometryType='VECTOR_CLUSTER'
          obj.mapLayer =clusters
          store.doAddLayer(obj) 
          dispatch({type: 'DS_LIBRARIES_SUCCESS', payload: { libraries: data, shouldParseUrl: true , clusterLayer: clusters, threeDLayer:libraryPoints}});
          dispatch({type:'LAYERS_LOADING_STOP', payload: { isLoading: false, isLoadingText: '' }});
        }
      }
    )
  },
  doDsParseUrl: () => ({dispatch, store, apiGet}) => {
    dispatch({ type: 'DS_PARSE_URL', payload: { shouldParseUrl: false }});
    const pathName = store.selectWindowLocationParams();
    const allLibrary = store.selectDsLibraries();
    const openProjects = Object.assign({}, store.selectOpenProjects());
    const loadingLibrary= store.selectDsLoadingLibrary();
    let libLength=0;
    let currLib =0
    const tbl=[]
    const cb =(projectType, libraryId, libraryName) => (err, response, body) => {
      currLib= currLib+1
      
      if(err || response.statusCode !== 200) {
        const libraryStatusIdx = findIndex(loadingLibrary, libraryName)
        if(libraryStatusIdx !== -1) {
          loadingLibrary[libraryStatusIdx].status ='error'
        }
        dispatch({type:'LAYERS_LOADING_STOP', payload: { isLoading: false, isLoadingText: '' }});
        dispatch({ type: 'DS_PROJECT_DATA_LOAD_ERROR', payload: { loadingLibrary,isLoading: false, isLoadingText: '', err: err, notification: {
          level: 'error',
          title: 'Failed To Retrive FIM Libraries',
          message: JSON.stringify(err)
        }}})
        
        
      }else{
        const data = JSON.parse(body);
        const rootKey = `root-${projectType}-${libraryId}`;
        
        store.doDSCreateRootNode(rootKey);
        if(openProjects[projectType][libraryId]) {
          if(projectType==='SIMDAMS') {
            openProjects['SIMDAMS'][libraryId].datasets = data;
          }else{
            openProjects['NID'][libraryId].datasets = data;
          }
          
          tbl.push({name:`root-${projectType}-${libraryId}`, type:projectType, id:libraryId})
          
        }
        if(currLib===libLength) {
          dispatch({type: 'DS_PROJECT_DATA_LOADED', payload: { openProjects: openProjects }});
          for(let i=0;i<tbl.length;i++) {
            const currObj = tbl[i]
            store.doDSLoadLayers(currObj.name, currObj.type, currObj.id);
          }
          dispatch({type:'LAYERS_LOADING_STOP', payload: { isLoading: false, isLoadingText: '' }});
          
          window.history.pushState({}, document.title, `./`);
        }
      }
      
    }

    if(pathName.dsLibrary) {
      const startLib = pathName.dsLibrary.split(',')
      libLength = startLib.length
      dispatch({type:'LAYERS_LOADING_START', payload: { isLoading: true, isLoadingText: 'Opening Libraries Found in URL' }});
      for(let i=0;i<startLib.length;i++) {
        const [type, id] = startLib[i].split('-')
        const library = find(allLibrary,(obj, idx) =>{
          if(type==='SIMDAMS') {
            return obj.LIBRARY_TYPE==='simdams' && obj.LIBRARY_ID == id 
          }else{
            return obj.id== id;
          }
        })
        if(typeof library !== 'undefined') {
          //store.doOpenProject(library)
          
          let projectType = 'NID';
          if(library.LIBRARY_TYPE==='simdams') {
            projectType = 'SIMDAMS'
          }
          if(!library.datasets) library.datasets = [];
          
          
          openProjects[projectType][library.id] = library;
          
          if(projectType==='NID') {
            const LIBRARY_ID = library.id;
            const libraryName = `NID-${LIBRARY_ID}`
            loadingLibrary.push({library:libraryName, status:'loading'})
            apiGet(`${cwbiHost}/fim/v2/getEAPLayers?id=${LIBRARY_ID}`, cb(projectType, library.id, startLib[i]))
          }else{
            const LIBRARY_ID = library.LIBRARY_ID;
            const libraryName = `SIMDAMS-${LIBRARY_ID}`
            loadingLibrary.push({library:libraryName, status:'loading'})
            apiGet(`${mmcHost}/simdams/layers/singleLibrary?SIMDAMS_INFO_ID=${LIBRARY_ID}`, cb(projectType, library.LIBRARY_ID, startLib[i]));
          }
        }
      }
    }
  },
  doDsAddSelect: () => ({dispatch, store}) => {
    dispatch({ type: 'DS_ADDED_SELECT', payload: { shouldAddSelect: false }});
    store.doSetCursor('default');
    const map = store.selectMap();
    map.addInteraction(selectPointerMove);

    map.addOverlay(popup);
    selectPointerMove.on('select', (e) => {
      let coord = [-999,-999];

      if(e.selected.length){
        const pt = e.selected[0];
        coord = pt.get('geometry').flatCoordinates;
      }
      
      ReactDOM.render(
        <ProjectPopup 
          hidden={!e.selected.length}
          features={e.selected} 
          onMouseOver={store.doDsPopupMouseover} 
          onMouseOut={store.doDsPopupMouseout}
          onItemClick={store.doOpenProject}
        />, 
        overlayDiv
      );
      popup.setPosition(coord);
    })
   
  },

  doDsPopupMouseover: () => ({dispatch}) => {
    selectPointerMove.setActive(false);
    dispatch({ type: 'DS_MOUSOVER', payload: { ignoreSelect: true }});
  },

  doDsPopupMouseout: () => ({dispatch}) => {
    selectPointerMove.setActive(true);
    dispatch({ type: 'DS_MOUSOUT', payload: { ignoreSelect: false }});
  },

  doLoadProjectDatasets: () => ({store}) => {
    const type = store.selectShouldLoadProjectType();
    if(type === 'simdams'){
      store.doLoadSimdamsProjectDatasets();
    }else{
      store.doLoadDSProjectDatasets();
    }
  },
  // ${cwbiHost}/fim/getEAPLayers?id=${LIBRARY_ID}
  // `${mmcHost}/usace/layers/singleLibrary?libraryID=${LIBRARY_ID}`
  doLoadDSProjectDatasets: () => ({dispatch, store, apiGet}) => {
    const LIBRARY_ID = store.selectShouldLoadProjectId();
    const loadingLibrary= store.selectDsLoadingLibrary();
    const libraryName = `NID-${LIBRARY_ID}`
    loadingLibrary.push({library:libraryName, status:'loading'})
    dispatch({type:'DS_PROJECT_DATA_LOADING', payload: { shouldLoadDatsets: false, shouldLoadProjectId: null, shouldLoadProjectType: null, loadingLibrary:loadingLibrary }});
    apiGet(`${cwbiHost}/fim/v2/getEAPLayers?id=${LIBRARY_ID}`, (err, response, body) => {
      if(err || response.statusCode !== 200){
        const loadingLibrary= store.selectDsLoadingLibrary();
        const libraryStatusIdx = findIndex(loadingLibrary, libraryName)
        if(libraryStatusIdx !== -1) {
          loadingLibrary[libraryStatusIdx].status ='error'
        }
        dispatch({ type: 'DS_PROJECT_DATA_LOAD_ERROR', payload: { loadingLibrary, err: err, notification: {
          level: 'error',
          title: 'Failed To Retrive FIM Library',
          message: JSON.stringify(err)
        }}})
        dispatch({type:'LAYERS_LOADING_STOP', payload: { isLoading: false, isLoadingText: '' }});
      }else{
        const data = JSON.parse(body);
        const openProjects = Object.assign({}, store.selectOpenProjects());
        const rootKey = `root-NID-${LIBRARY_ID}`;
        
        store.doDSCreateRootNode(rootKey);
        if(openProjects['NID'][LIBRARY_ID]) {
          // openProjects['IWRSS'][LIBRARY_ID].datasets = flatten(data);
          openProjects['NID'][LIBRARY_ID].datasets = data;
          
          dispatch({type: 'DS_PROJECT_DATA_LOADED', payload: { openProjects: openProjects }});
          store.doDSLoadLayers(`root-NID-${LIBRARY_ID}`, 'NID', LIBRARY_ID);
        }
        
      }
    })
  },

  // doLoadSimdamsProjectDatasets: () => ({dispatch, store, apiGet}) => {
  //   const LIBRARY_ID = store.selectShouldLoadProjectId();
  //   const loadingLibrary= store.selectDsLoadingLibrary();
  //   const libraryName = `SIMDAMS-${LIBRARY_ID}`
  //   loadingLibrary.push({library:libraryName, status:'loading'})
  //   dispatch({type:'DS_PROJECT_DATA_LOADING', payload: { shouldLoadDatsets: false, shouldLoadProjectId: null, shouldLoadProjectType: null, loadingLibrary:loadingLibrary }});
  //   apiGet(`${mmcHost}/simdams/layers/singleLibrary?SIMDAMS_INFO_ID=${LIBRARY_ID}`, (err, response, body) => {
  //     if(err || response.statusCode !== 200){
  //       const loadingLibrary= store.selectDsLoadingLibrary();
  //       const libraryStatusIdx = findIndex(loadingLibrary, {library:libraryName})
  //       if(libraryStatusIdx !== -1) {
  //         loadingLibrary[libraryStatusIdx].status ='error'
  //       }
  //       dispatch({ type: 'DS_PROJECT_DATA_LOAD_ERROR', payload: { loadingLibrary, err: err, notification: {
  //         level: 'error',
  //         title: 'Failed To Retrive SIMDAMS Library',
  //         message: JSON.stringify(err)
  //       }}})
  //     }else{
  //       const data = JSON.parse(body);
  //       const openProjects = Object.assign({}, store.selectOpenProjects());
  //       const rootKey = `root-SIMDAMS-${LIBRARY_ID}`;
        
  //       store.doDSCreateRootNode(rootKey);
  //       if(openProjects['SIMDAMS'][LIBRARY_ID]) {
  //         openProjects['SIMDAMS'][LIBRARY_ID].datasets = data;
  //         dispatch({type: 'DS_PROJECT_DATA_LOADED', payload: { openProjects: openProjects }});
  //         store.doDSLoadLayers(`root-SIMDAMS-${LIBRARY_ID}`,'SIMDAMS', LIBRARY_ID);
  //       }
        
  //     }
  //   })
  // },

  doDSCreateRootNode: (id) => ({dispatch, store}) => {
    //store.doTreeRemove(id)
    store.doAddLayer({
      id: id,
      root: true,
      leaf: false,
      teamDatasetId: null,
      collapsed: false,
      visible: false,
      sortOrder: 0,
      displayName: 'Root',
      type: 'Folder'
    })
    dispatch({type:'DS_ROOT_CREATED', payload:{}});
  },

  doDSLoadLayers: (rootId, projectType, LIBRARY_ID) => ({dispatch, store}) => {
    const idMap = store.selectIdMap();
    const rootUid = idMap[rootId];
    const statusChange = store.selectDsStatusChange();
    const projects = store.selectOpenProjects();
    const layers = projects[projectType][LIBRARY_ID].datasets;
    const libraryName = `${projectType}-${LIBRARY_ID}`;
    const urlType = libraryName.split('-')[0];
    for(let i =0; i<layers.length; i++) {
      
      
      layers[i].info={
        url:`${cwbiHost}/info/getExtent?type=layer&layer=${layers[i].layerList[0]}&library=${libraryName}&id=0`,
        libraryId: LIBRARY_ID,
        parentTableId: layers[i].parentTableID,
        parentTable: 'SCENARIO_INCREMENT'
      };
    }
    const sortedLayers = orderBy(layers, ['parentId', 'layerOrder', 'displayName'], ['desc', 'asc', 'desc']);
    
    sortedLayers.forEach((lyr) => {
     
      if(lyr.parentId){
        const idMap = store.selectIdMap();
        lyr.parentUid = idMap[lyr.parentId]
      }else{
        lyr.parentUid = rootUid
      }
      if(lyr.data){
        lyr.features = (new GeoJSON()).readFeatures(lyr.data, {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
        lyr.style = mapExtentStyle;
        lyr.dlUrl = lyr.dlUrl
      } 
      lyr.libraryName = libraryName;
      if(!lyr.hasOwnProperty('visible')) lyr.visible = false;
      const urlType = libraryName.split('-')[0];
      if(lyr.type !=='Folder') {
        lyr.dsName=urlType;

        if(lyr.layerList && (lyr.layerList[0]==='cog_layer' || lyr.layerList[0]==='cog_xyz'|| lyr.layerList[0]==='flood_extent_raster')) {
          lyr.info.rasterClass=[
            {
              name:'4_1',
              low: 0,
              high: 2,
              color:'203 242 245'
            },
            {
              name:'4_2',
              low:2,
              high:6,
              color:'140 190 237'
            },
            {
              name:'4_3',
              low:6,
              high:15,
              color:'100 139 217'
            },
            {
              name:'4_4',
              low:15,
              high: null,
              color:'84 84 179'
            }
          ];
          lyr.info.classGroup = lyr.classgroup;
          lyr.info.s3Location = lyr.s3Location;
          lyr.info.layerId = lyr.layerId;
          
        }        
      }
      store.doAddLayer(lyr)      
    })
    //store.doBulkAddLayer(bulkLayers, rootUid, 'DS_LAYER_TREE_LOADED');
    const loadingLibrary= store.selectDsLoadingLibrary();
    const libraryStatusIdx = findIndex(loadingLibrary, {library:libraryName});
    if(libraryStatusIdx !== -1) {
      if(layers && layers.length>0) {
        loadingLibrary[libraryStatusIdx].status ='loaded'
      }else {
        loadingLibrary[libraryStatusIdx].status ='noSpatial'
      }
    }
    //store.doBulkAddLayer(bulkLayers, rootUid, 'DS_LAYER_TREE_LOADED', libraryName);
    dispatch({type:'DS_LAYER_TREE_LOADED', payload: {loadingLibrary: loadingLibrary, statusChange:!statusChange }});
  },
  doChangeLoadingLibraryStatus: (libraryName) => ({dispatch, store}) => {
    const loadingLibrary= store.selectDsLoadingLibrary();
    const libraryStatusIdx = findIndex(loadingLibrary, {library:libraryName});
    const statusChange = store.selectDsStatusChange();
    if(libraryStatusIdx !== -1) {
        loadingLibrary[libraryStatusIdx].status ='loading';     
    }
    
    dispatch({type:'DS_LAYER_TREE_LOADED', payload: {loadingLibrary: loadingLibrary, statusChange:!statusChange }});    
  },
  doDsOpenLayerConfig: (item) => ({dispatch, store}) => {
    function cb(rootId) {
      dispatch({type: 'DS_CONFIG_PICKED', payload: { shouldRenderConfig: true, selectedItem: item, configRoot:rootId, subPanelType: 'layerConfig' }});
    }
    getRoot(item, cb);    
  },

  doDsRenderLayerConfig: () => ({dispatch, store}) => {        
    dispatch({type: 'DS_CONFIG_DISPLAYED', payload: { shouldRenderConfig: false}});
    store.doOpenPrimaryPanel({
      openedBy: 'ds-tree',
      children:[ LayerSubpanel ]
    })
  },
  doDsOpenMSExplorer: (item) => ({dispatch, store}) => {
    function cb(rootId) {
      dispatch({type: 'DS_MSEXPLORER_PICKED', payload: { shouldRenderMSExplorer: true, selectedItem: item, configRoot:rootId, subPanelType: 'msExplorer' }});
    }
    getRoot(item, cb);    
  },

  doDsRenderMSExplorer: () => ({dispatch, store}) => {        
    dispatch({type: 'DS_MSEXPLORER_DISPLAYED', payload: { shouldRenderMSExplorer: false}});
    store.doOpenPrimaryPanel({
      openedBy: 'ds-tree',
      children:[ LayerSubpanel ]
    })
  },
  doDsOpenRasterReclass: (item) => ({dispatch, store}) => {
    function cb(rootId) {
      dispatch({type: 'DS_RASTER_RECLASS_PICKED', payload: { shouldRenderRasterReclass: true, selectedItem: item, configRoot:rootId, subPanelType: 'rasterReclass' }});
    }
    getRoot(item, cb);    
  },

  doDsRenderRasterReclass: () => ({dispatch, store}) => {        
    dispatch({type: 'DS_RASTER_RECLASS_DISPLAYED', payload: { shouldRenderRasterReclass: false}});
    store.doOpenPrimaryPanel({
      openedBy: 'ds-tree',
      children:[ LayerSubpanel ]
    })
  },
  // doDsOpenMapsOnDemand: (item) => ({dispatch, store}) => {
  //   function cb(rootId) {
  //     dispatch({type: 'DS_MAPS_ON_DEMAND_PICKED', payload: { shouldRenderMapsOnDemand: true, selectedItem: item, configRoot:rootId, subPanelType: 'mapsOnDemand' }});
  //   }
  //   getRoot(item, cb);    
  // },

  // doDsRenderMapsOnDemand: () => ({dispatch, store}) => {        
  //   dispatch({type: 'DS_MAPS_ON_DEMAND_DISPLAYED', payload: { shouldRenderMapsOnDemand: false}});
  //   store.doOpenPrimaryPanel({
  //     openedBy: 'ds-tree',
  //     children:[ LayerSubpanel ]
  //   })
  // },
  doDsFolderSetOpen: (libraryName, nodeId, collapsed) => ({dispatch, store}) => {        
    let openFolders = concat([],store.selectDsOpenFolders());
    const libraryIdx = findIndex(openFolders, {library:libraryName});
    
    if(libraryIdx !== -1) {
      
     
      if(collapsed!==false) {
        const newArr = openFolders[libraryIdx].openFolders.splice(nodeId.toString(),1)
      }else{
        openFolders[libraryIdx].openFolders.push(nodeId)
      }
      
    }else{
      openFolders.push({library:libraryName, openFolders:[nodeId]})
    }
    dispatch({type:'DS_PROJECT_FOLDER_CHANGE', payload: {openFolders: openFolders}});  
  },
  doDsCloseSubPanel: () => ({dispatch, store}) => {
    const libraryInfo = store.selectDsConfigRootId().split('-');
    const libraryId = libraryInfo[2];
    const libraryType = libraryInfo[1];
    const openProjects = store.selectOpenProjects()
    const library = openProjects[libraryType][libraryId];
    if(library) {
      store.doOpenPrimaryPanel({
        openedBy: 'ds-tree',
        options: {library: library, datasets: null},
        children:[ ProjectPanel ]
      })
    }
    dispatch({type: 'DS_CONFIG_DISPLAYED', payload: { shouldRenderConfig: false, shouldRenderMSExplorer: false, configRoot: null, selectedItem: null, subPanelType: null}});
  },
  doDsIdentRegister: () => ({dispatch, store}) => {
    dispatch({type: 'DS_IDENT_REGISTERED', payload: { shouldRegister: false }});
    store.doIdentifyAddCollection({
      onIdentify: store.doDsIdentFire
    })
  },

  doDsIdentFire: (callback) => ({dispatch, store, anonGet}) => {
    const coords = store.selectIdentifyCoordinates();
    const root = store.selectApiRoot();
    const visibleLayers = store.selectVisibleDsLayers();
    const resolution = store.selectResolution();
    if(!visibleLayers.length) return callback(null, []);
    const tables=[];
    for(let i=0; i< visibleLayers.length; i++) {
      const lyr = visibleLayers[i].layer;
      if(lyr.layerList[0] === 'cog_xyz' || lyr.layerList[0] === 'flood_extent_raster') {
        const obj = {
          displayName: lyr.displayName,
          dataset: lyr.dsName,
          id: lyr.info.parentTableId,
          type: 's3',
          location: lyr.info.s3Location
        }
        if(lyr.parent) {
          obj.displayName =`${lyr.parent.displayName} ${lyr.displayName}`
        }
        tables.push(obj)
      }else{
        const obj = {
          displayName: (lyr.displayName).replace(/&/g, 'and'),
          dataset: lyr.dsName,
          type: 'vector',
          table:lyr.layerList[0],
          id: lyr.info.parentTableId
        }
        if(lyr.parent && !lyr.parent.root) {
          obj.displayName =`${lyr.parent.displayName} ${(lyr.displayName).replace(/&/g, 'and')}`
        }
        tables.push(obj)
      }
    }
    let url;
    const params = {
      root: `${mmcHost}/identify`,
      tables: JSON.stringify(tables),
      mapExtent: store.selectMapExtent(),
      imageDisplay: store.selectMapImageDisplay()
    }

    if(typeof coords[0] === 'number'){
      params.lonlat = coords;
      params.dist = resolution * 5;
      url = `${mmcHost}/identify?tables=${params.tables}&mapExtent=${params.mapExtent}&imageDisplay=${params.imageDisplay}&lonlat=${params.lonlat}&dist=${params.dist}`;
      url=encodeURI(url)
    }else{
        const gjson = {
          'type': 'FeatureCollection',
          'features':[
            {
              'type': 'Feature',
              'geometry': {
                'type': 'Polygon',
                'coordinates': coords
              },
              'properties': {}
            }]
        };
      params.bbox = JSON.stringify(gjson)
      url = `${mmcHost}/identify?tables=${params.tables}&mapExtent=${params.mapExtent}&imageDisplay=${params.imageDisplay}&bbox=${params.bbox}`;
      url=encodeURI(url)
    }
    
    anonGet(url, (err, response, body) => {
      if(err || response.statusCode !== 200){
        callback({err: err, response: response});
      }else{
        const data = JSON.parse(body)
        callback(null, data);
      }
    })
  },
  
  
  selectOpenProjects: (state) => {
    return state.ds.openProjects;
  },
  selectDsConfigRootId: (state) => {
    return state.ds.configRoot;
  },
  selectVisibleDsLayers: createSelector(
    'selectLayers',
    (layers) => {
      const dsLayers = [];
      Object.keys(layers).forEach((key) => {
        if(layers[key] && layers[key].dsName && layers[key].visible && (layers[key].geometryType==='SERVICE' || layers[key].geometryType==='VECTOR_CLUSTER') 
        && (layers[key].dsName === 'SIMDAMS' || layers[key].dsName === 'NID' || layers[key].dsName === 'HSIP'
         || (layers[key].dsName === 'USACE' && layers[key].displayName!=='USACE Districts' && layers[key].displayName!=='USACE Divisions' && layers[key].displayName!=='REMIS Civil Works Land Parcel Area') || layers[key].dsName === 'NATIONAL' || layers[key].dsName === 'NID' || layers[key].dsName === 'POLITICAL')
        ) {
          
          dsLayers.push({
              layer:layers[key],
            });
        } 
      })
      return dsLayers;
    }
  ),
  selectShouldLoadProjectId: (state) => {
    return state.ds.shouldLoadProjectId;
  },
  selectDsSelectedItem: (state) => {
    return state.ds.selectedItem;
  },
  selectDsLoadProjectId: (state) => {
    return state.ds.shouldLoadProjectId;
  },
  selectDSClusterLayer: (state) => {
    return state.ds.clusterLayer;
  },
  selectDSThreeDLayer: (state) => {
    return state.ds.threeDLayer;
  },
  selectDsRootId: (state) => {
    return state.ds.rootId;
  },
  selectShouldLoadProjectType: (state) => {
    return state.ds.shouldLoadProjectType;
  },
  selectDsLoadingLibrary: (state) => {
    return state.ds.loadingLibrary;
  },
  selectDsOpenFolders: (state) => {
    return state.ds.openFolders;
  },
  selectDsLibraries: (state) => {
    return state.ds.libraries;
  },
  selectDsCheckingExtent: (state) => {
    return state.ds.checkingExtent;
  },
  selectDsStatusChange: (state) => {
    return state.ds.statusChange;
  },
  selectDsSubPanelType: (state) => {
    return state.ds.subPanelType
  },
  selectDsShouldRenderRasterReclass: (state) => {
    return state.ds.shouldRenderRasterReclass
  },
  selectDsShouldRenderMapsOnDemand: (state) => {
    return state.ds.shouldRenderMapsOnDemand
  },
  reactDsShouldRegister: (state) => {
    if(state.ds.shouldRegister) return { actionCreator: 'doDsIdentRegister' };
  },       
  reactShouldLoadDatasets: (state) => {
    if(state.ds.shouldLoadDatsets) return { actionCreator: 'doLoadProjectDatasets' };
  },
  reactShouldLoadLibraries: (state) => {
    if(state.ds.shouldLoadLibraries) return ({ actionCreator: 'doLoadLibraries' });
  },
  reactShouldAddSelect: (state) => {
    if(state.ds.shouldAddSelect) return ({ actionCreator: 'doDsAddSelect' });
  },
  reactShouldRenderDSLayerConfig: (state) => {
    if(state.ds.shouldRenderConfig) return { actionCreator: 'doDsRenderLayerConfig' };
  },
  reactShouldRenderDSMSExplorer: (state) => {
    if(state.ds.shouldRenderMSExplorer) return { actionCreator: 'doDsRenderMSExplorer' };
  },
  reactShouldRenderDSRasterReclass: (state) => {
    if(state.ds.shouldRenderRasterReclass) return { actionCreator: 'doDsRenderRasterReclass' };
  },
  reactShouldRenderDSMapsOnDemand: (state) => {
    if(state.ds.shouldRenderMapsOnDemand) return { actionCreator: 'doDsRenderMapsOnDemand' };
  },
  reactDsShouldParseUrl: (state) => {
    if(state.ds.shouldParseUrl) return { actionCreator: 'doDsParseUrl' };
  },
  reactDsShouldLoadHSIP: (state) => {
    if(state.ds.shouldLoadHSIP) return { actionCreator: 'doDsLoadHSIPLayers' };
  },
  init: (store) => {
    // store.doDsShowDisclaimer()
    // store.doOpenModalWindow({
    //   children: [Disclaimer],
    //   options: {},
    //   openedBy: 'ds- bundle'
    // })
  }, 
}